import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import bobineCb from "@/assets/products/bobine-thermique-cb.png";
import bobineCaisse from "@/assets/products/bobine-thermique-addition.png";

const config: ProductPageConfig = {
  name: "Bobines thermiques & CB",
  breadcrumbName: "Bobines thermiques",
  subtitle: "Bobines pour caisses enregistreuses et terminaux de paiement",
  features: ["Papier thermique", "Compatible TPE", "Disponible en stock"],
  variants: [
    { name: "Bobine CB 57x40", dimensions: "57 x 40 x 12 mm", material: "Papier thermique", packaging: "Carton de 50 (5 x 10)", palette: "150 cartons", image: bobineCb },
    { name: "Bobine caisse 80x80", dimensions: "80 x 80 x 12 mm", material: "Papier thermique", packaging: "Carton de 30 (3 x 10)", palette: "72 cartons", image: bobineCaisse },
  ],
};

const BobineThermique = () => <ProductPageLayout config={config} />;
export default BobineThermique;
